import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { forEach, get } from 'lodash'
import GratifyProvider from "./provider";

import { plugins, PLUGIN_SELECTOR, getProps, LoadableVideoEmbed as VideoEmbed, LoadableAuth as Auth, LoadableBuyButton as BuyButton, LoadableVideoPlayer as VideoPlayer } from './definitions'

export { BuyButton, VideoPlayer, Auth, VideoEmbed, GratifyProvider }

const isReady = () => {
  return new Promise((resolve, reject) => {
    try {
      if (/comp|inter|loaded/.test(document.readyState)) {
        resolve();
      }else {
        document.addEventListener( 'DOMContentLoaded', function( event ) {
          resolve();
        });
      }
    } catch(e) {
      resolve();
    }
  })
};

export const renderPlugins = async (store) => {
  await isReady();

  const pluginNodes = document.querySelectorAll(PLUGIN_SELECTOR);

  forEach(pluginNodes, (node) => {
    const type = node.dataset.gfyPlugin || node.dataset.ecPlugin;
    const plugin = get(plugins, type);
    if(plugin) {
      const props = getProps(plugin, node);
      const { Component } = plugin;

      ReactDOM.render(
        <Provider store={store}>
          <Component {...props } rootNode={ node } />
        </Provider>,
        node
      );
    }
  });
};
